/**
 * Formatierung und Datums-Hilfen
 */

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('de-DE');
};

export const addDays = (dateString, days) => {
  const result = new Date(dateString);
  result.setDate(result.getDate() + days);
  return result.toISOString().split('T')[0];
};

export const addMonth = (dateString) => {
  const result = new Date(dateString);
  result.setMonth(result.getMonth() + 1);
  return result.toISOString().split('T')[0];
};

export const addInterval = (dateString, interval) => {
  const result = new Date(dateString);
  switch (interval) {
    case 'monthly':
      result.setMonth(result.getMonth() + 1);
      break;
    case 'quarterly':
      result.setMonth(result.getMonth() + 3);
      break;
    case 'semiannually':
      result.setMonth(result.getMonth() + 6);
      break;
    case 'yearly':
      result.setFullYear(result.getFullYear() + 1);
      break;
    default:
      result.setMonth(result.getMonth() + 1);
  }
  return result.toISOString().split('T')[0];
};

export const getIntervalLabel = (interval) => {
  const labels = {
    monthly: 'Monatlich',
    quarterly: 'Vierteljährlich',
    semiannually: 'Halbjährlich',
    yearly: 'Jährlich',
  };
  return labels[interval] || interval;
};

export const getCustomerFullName = (customer) => {
  if (!customer) return '';
  return [customer.salutation, customer.firstName, customer.lastName].filter(Boolean).join(' ');
};
